"use client";

import * as React from "react";

import {
  PopoverMenu,
  PopoverMenuItem,
  PopoverMenuSection,
} from "@/components/ui/popover-menu";
import type { TaskStatus } from "@/lib/tasks/queries";

import {
  STATUS_LABELS,
  STATUS_PICKER_ORDER,
  TaskStatusIcon,
} from "./task-status-icon";

type Props = {
  value: TaskStatus;
  onChange: (next: TaskStatus) => void;
  trigger: React.ReactElement;
  disabled?: boolean;
};

/**
 * Controlled status picker. Used in two places:
 * - The task card (parent's `onChange` PATCHes /api/tasks/{id} and refreshes)
 * - The new-task modal (parent's `onChange` updates local form state)
 *
 * Same UI in both — the parent owns whether the change persists.
 */
export function TaskStatusMenu({ value, onChange, trigger, disabled }: Props) {
  const [open, setOpen] = React.useState(false);

  const select = (next: TaskStatus) => {
    if (next !== value) onChange(next);
    setOpen(false);
  };

  return (
    <PopoverMenu
      open={open}
      onOpenChange={setOpen}
      trigger={trigger}
      menuContentClassName="w-[10.5rem]"
      menu={
        <PopoverMenuSection>
          {STATUS_PICKER_ORDER.map((status) => (
            <PopoverMenuItem
              key={status}
              icon={<TaskStatusIcon status={status} />}
              label={STATUS_LABELS[status]}
              selected={status === value}
              disabled={disabled}
              onClick={() => select(status)}
            />
          ))}
        </PopoverMenuSection>
      }
    />
  );
}
